import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"justify":"center"}},[_c(VBtn,{class:[ _vm.$vuetify.breakpoint.lgAndUp ? 'menu-open' : '', 'px-2'],staticStyle:{"margin-bottom":"20px","width":"90%"},attrs:{"large":"","rounded":"","fixed":"","bottom":"","color":"primary","px-2":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }